/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.HomePage';

export default defineMessages({
  forecast: {
    id: `${scope}.forecast`,
    defaultMessage: 'Enter your expected U.S. equity market forecast and the participation rate and spread for the FIA you are selling. Using your expected forecast, the Tool will calculate the expected annual FIA Product return.',
  },
  product: {
    id: `${scope}.product`,
    defaultMessage: 'Enter your expected FIA product return below to quickly calculate the U.S. Equity market return needed.',
  },
});